import React, { Fragment } from 'react';
import { string, shape } from 'prop-types';
import _ from 'lodash';
import { Small } from 'components/common';
import './SectionInfoItem.scss';

const SectionInfoItem = ({
  type,
  value,
  description,
}) => {
  const fieldValue = (description && description.shortDescription) || value;
  return (
    <Fragment>
      {fieldValue && (
        <div className="section-list-item">
          <div className="section-list-item-name">
            <strong>{type.display}</strong>
          </div>
          <div className="section-list-item-value">
            {_.isString(fieldValue) && fieldValue.split('\n').map(item => (
              <span key={item}>
                {item}
                <br />
              </span>
            ))}
            {description && description.longDescription && (
              <div>
                <Small secondary>{description.longDescription}</Small>
              </div>
            )}
          </div>
        </div>
      )}
    </Fragment>
  );
};

SectionInfoItem.defaultProps = {
  description: null,
  value: null,
};

SectionInfoItem.propTypes = {
  type: shape({}).isRequired,
  value: string,
  description: shape({}),
};

export default SectionInfoItem;
